const UserRoles = Object.freeze({
  All: "All",
  SuperAdmin: "Super Admin",
  CXO: "CXO",
  Executive: "Executive",
  Manager: "Manager",
  Viewer: "Viewer",
});

const AllRolesExceptViewer = [
  UserRoles.SuperAdmin,
  UserRoles.CXO,
  UserRoles.Executive,
  UserRoles.Manager,
];

export { AllRolesExceptViewer };
export default UserRoles;
